<template>
  <div class="Price">
    {{ priceFormat(price) }}€<sup>{{ priceTaxe }}</sup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import priceFormat from "../utils/priceFormat";

export default {
  name: "Price",
  props: {
    price: {
      type: Number,
      required: true
    }
  },
  computed: mapGetters("auth", ["priceTaxe"]),
  methods: {
    priceFormat(cents) {
      return priceFormat(cents);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.Price {
  font-weight: 900;

  sup {
    font-size: 0.5em;
  }
}
</style>
